import type { PropType } from 'virtual-vue';
import type { RadioIcon } from './radio'

/**
 * radio组件的props
 */
export const radioProps = {
  /**
   * 是否允许取消选中
   * @default false
   */
  allowUncheck: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否选中
   * @default false
   */
  checked: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否为禁用态
   */
  disabled: Boolean,
  /**
   * 单选按钮的值
   */
  value: {
    type: [String, Number, Boolean] as PropType<string | number | boolean>,
  },
  /**
   * 主文案
   */
  label: String,
  /**
   * 描述文案
   */
  desc: String,
  /**
   * 自定义左侧图标
   */
  icon: {
    type: [Object] as PropType<RadioIcon>,
    default: undefined,
  },

  /**
   * 底部分割线右边距是否占满
   * @default true
   */
  marginLess: {
    type: Boolean,
    default: true,
  },
};
